import './bookmark.scss';

import enquire from 'enquire.js';
import { Responsive } from '../utils';

const COMPONENT_NAME = 'bookmark';
const BEM = {
  BLOCK: COMPONENT_NAME,
  CONTENT_LIST: 'bookmark__content',
};

/**
 * version    1.0
 * class      <type> (Bookmark)
 * classdesc  bookmark
 */
export class Bookmark {
  constructor() {
    this._findUIElements();
    this._bindEvents();
  }

  // private methods

  _findUIElements() {
    this._els = {
      activeItem: '',
      mobileOpenCategories: false,
      bookmark: $(`.${BEM.BLOCK}`),
      contentList: $(`.${BEM.CONTENT_LIST}`),
    };
  }

  _bindEvents() {
    const self = this;

    // Desktop
    enquire.register(`${Responsive.getBreakpointMinMediaQuery('md')}`, () => {
      self._initScrollspy();
      self._setActiveEl();
      self._changeActiveEl();
      self._moveActiveLine();
      self._changeActiveLine();

      window.addEventListener('scroll', () => {
        self._changeActiveEl();
        self._changeUrlParameter();
      });
    });

    // Mobile
    enquire.register(`${Responsive.getBreakpointMaxMediaQuery('sm')}`, () => {
      self._mobileLinkClick();
      self._mobileScroll();
      self._mobileShadowClick();
    });
  }

  _mobileScroll() {
    $(document).on('click', '.nav-link', (e) => {
      e.preventDefault();

      const clickedBookmark = e.currentTarget;
      const idBookmarkToScroll = $(clickedBookmark).attr('href');

      $('html, body').animate({
        scrollTop: $(idBookmarkToScroll).offset().top - 70,
      }, 1000);
    });
  }

  _mobileLinkClick() {
    const self = this;

    $(document).on('click', '.bookmark__categories, .nav-item', (e) => {
      if ($(e.currentTarget).hasClass('nav-item') || ($(e.currentTarget).hasClass('bookmark__categories') && $('.bookmark').hasClass('open'))) {
        self._els.mobileOpenCategories = true;
      }

      // apre chiude le categories
      $('.bookmark__content').slideToggle();

      // aggiungo shadow anche su header
      $('header.header').toggleClass('header-shadow');

      // aggiungo class open per ruotare la arrow e mettere la shadow
      $('.bookmark').toggleClass('open');

      // questa classe blocca lo scroll verticale
      $('body').toggleClass('modal-open');
    });
  }

  _mobileShadowClick() {
    const self = this;

    $(document).on('click', '.bookmark.open', () => {
      if (!self._els.mobileOpenCategories) {
        // apre chiude le categories
        $('.bookmark__content').slideToggle();

        // aggiungo shadow anche su header
        $('header.header').toggleClass('header-shadow');

        // aggiungo class open per ruotare la arrow e mettere la shadow
        $('.bookmark').toggleClass('open');

        // questa classe blocca lo scroll verticale
        $('body').toggleClass('modal-open');
      }

      self._els.mobileOpenCategories = false;
    });
  }

  _initScrollspy() {
    $('body').attr('data-spy', 'scroll');
    $('body').attr('data-target', '#myScrollspy');
    $('body').attr('data-offset', 550);
  }

  _setActiveEl() {
    const self = this;

    if (window.location.hash.length > 0 && self._els.contentList.find('a.active').length === 0) {
      // se ho un parametro nell'url imposto quello come attivo se non ce ne sono di attivi (primo caricamento)
      self._els.contentList.find(`[href="${window.location.hash}"]`).addClass('active');
    } else if (window.location.hash.length === 0 && self._els.contentList.find('a.active').length === 0) {
      // se non ho un parametro nell'url imposto il primo link attivo se non ce ne sono di attivi (primo caricamento)
      self._els.contentList.find('li').first().find('a').addClass('active');
    }
  }

  _changeActiveEl() {
    const self = this;

    if ($(window).scrollTop() + $(window).height() === $(document).height()) {
      self.activeItem = self._els.contentList.find('.nav-item:last-child a');
    } else {
      self.activeItem = self._els.contentList.find('a.active');
    }
  }

  _moveActiveLine() {
    const self = this;

    // cerco l'indice dell'item con class .active
    const indexItemActive = self._els.contentList.find('a').index(self.activeItem);

    // recupero l'altezza del liConMargin per lo spostamento e del li per centrare la line con la voce
    const altezzaLi = self._els.contentList.find('li:not(.bookmark__active-line)').outerHeight(false);
    const altezzaLiConMargin = self._els.contentList.find('li:not(.bookmark__active-line)').outerHeight(true);

    const $activeLine = $('.bookmark__active-line');
    // setto altezza della .bookmark__active-line tolgo 1 che è l'altezza dell'asta
    $activeLine.css({
      'margin-top': `${altezzaLi / 2 - 0.5}px`,
      'margin-bottom': `${altezzaLi / 2 - 0.5}px`,
    });

    // sposto la active line sull'elemento active con animate
    $activeLine.stop().animate({
      top: `${altezzaLiConMargin * indexItemActive}px`,
    }, 600);
  }

  _changeUrlParameter() {
    const self = this;

    if ($('.bookmark').length > 0) {
      const oldParamUrl = window.location.hash;
      const newParamUrl = self.activeItem.attr('href');

      if (oldParamUrl !== newParamUrl) {
        const url = window.location.toString().replace(oldParamUrl, newParamUrl);

        window.history.pushState({}, '', url);
        self._changeActiveEl();
        self._moveActiveLine();
      }
    }
  }

  _changeActiveLine() {
    const self = this;

    self._els.contentList.find('.nav-link').on('click', (e) => {
      e.preventDefault();

      const clickedEl = e.currentTarget;
      const idToScroll = $(clickedEl).attr('href');

      $('html, body').animate({
        scrollTop: $(idToScroll).offset().top - 350,
      }, 1000);
    });
  }
}
